import PropTypes from 'prop-types';
import { Popover, PopoverContent, PopoverTrigger } from '../../ui/popover';


/**
 *
 * @param root0
 * @param root0.trigger
 * @param root0.triggerClass
 * @param root0.content
 * @param root0.contentClass
 * @param root0.asChild
 * @param root0.align
 * @param root0.side
 * @param root0.isOpen
 * @param root0.onOpenChange
 * @returns {JSX} PopoverHelper
 */
function PopoverHelper({ trigger, triggerClass, content, contentClass, asChild = false, align, side, isOpen, onOpenChange }) {
    return (
        <Popover open={isOpen} onOpenChange={onOpenChange}>
            <PopoverTrigger className={triggerClass} asChild={asChild}>
                {
                    trigger
                }
            </PopoverTrigger>
            <PopoverContent className={contentClass} align={align || 'start'} side={side || 'bottom'}>
                {
                    content
                }
            </PopoverContent>
        </Popover>
    );
}

PopoverHelper.propTypes = {
    isOpen: PropTypes.bool,
    onOpenChange: PropTypes.func.isRequired,
    trigger: PropTypes.element.isRequired,
    triggerClass: PropTypes.string,
    content: PropTypes.element.isRequired,
    contentClass: PropTypes.string,
    asChild: PropTypes.bool,
    align: PropTypes.string,
    side: PropTypes.string
};

export default PopoverHelper;